//descriptionGeneral is mockup this value is fetched from wordpress


export const directions = {
  todosServicios:0,
  confotur:1,
  empresaServicios:2,
  dpp:3
}

export const localDirections = [
  {
    id:0,
    wordpressID:130,
    wordpressKey:'todosServicios',
    title:'Todos los servicios',
  },
  {
    id:1,
    wordpressID:133,
    wordpressKey:'dpp',
    title:'Admisiones',
  },
  {
    id:2,
    wordpressID:132,
    wordpressKey:'confotour',
    title:'Investigación y Divulación Científica',
  },
  {
    id:3,
    wordpressID:134,
    wordpressKey:'empresaServicios',
    title:'Extension Universitaria',
  },
]
